import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { nodes } from '../convert-prosemirror-to-markdown/pm-markdown/serializer';

/**
 * Extracts the support levels for each node type from the given NodeSerializerSpec.
 *
 * @example
 * ```ts
 * const supportLevels = getNodeSupport();
 * console.log(supportLevels);
 * // Output:
 * // {
 * //   blockquote: 'full',
 * //   codeBlock: 'full',
 * // }
 * ```
 */
export var getNodeSupport = function getNodeSupport() {
  var nodeSupport = Object.fromEntries(Object.entries(nodes).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [key, value.support];
  }));
  return nodeSupport;
};